/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookUpReferenceNumberResponse
 */
export interface LookUpReferenceNumberResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof LookUpReferenceNumberResponse
     */
    shipmentIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LookUpReferenceNumberResponse
     */
    isValid: boolean;
    /**
     * 
     * @type {string}
     * @memberof LookUpReferenceNumberResponse
     */
    message: string;
}

/**
 * Check if a given object implements the LookUpReferenceNumberResponse interface.
 */
export function instanceOfLookUpReferenceNumberResponse(value: object): value is LookUpReferenceNumberResponse {
    if (!('shipmentIds' in value) || value['shipmentIds'] === undefined) return false;
    if (!('isValid' in value) || value['isValid'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function LookUpReferenceNumberResponseFromJSON(json: any): LookUpReferenceNumberResponse {
    return LookUpReferenceNumberResponseFromJSONTyped(json, false);
}

export function LookUpReferenceNumberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookUpReferenceNumberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentIds': json['shipmentIds'],
        'isValid': json['isValid'],
        'message': json['message'],
    };
}

  export function LookUpReferenceNumberResponseToJSON(json: any): LookUpReferenceNumberResponse {
      return LookUpReferenceNumberResponseToJSONTyped(json, false);
  }

  export function LookUpReferenceNumberResponseToJSONTyped(value?: LookUpReferenceNumberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentIds': value['shipmentIds'],
        'isValid': value['isValid'],
        'message': value['message'],
    };
}

